export const showAddSettingsModal = () => {
    return {
      type: "SHOW_ADD_SETTINGS_MODAL",
    };
  };
  
  export const hideAddSettingsModal = () => {
    return {
      type: "HIDE_ADD_SETTTINGS_MODAL",
    };
  };
  